export enum Variant {
  WHITE = 'white',
  GRAY = 'gray',
}
